export const commissionSchemeOptions = [
  { text: 'Omipay', value: 'omipay' },
  { text: 'Vector MFC Broker', value: 'vector_mfc_broker' },
  { text: 'Vector MFC Franchise', value: 'vector_mfc_franchise' },
];
